module.exports = __webpack_public_path__ + "static/img/bg.4267279.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.gif
// module id = bTio
// module chunks = 1